import React, { useState, useEffect } from "react";
import { Button, Form, Container, Card } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import API_DOMAIN from "../config/config";
import AppBar from "./AppBar";
import { useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify"; // Correct import for toastify
import "react-toastify/dist/ReactToastify.css"; // Import toastify CSS

const Review = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [rating, setRating] = useState(0);
  const [customerId, setCustomerId] = useState("");
  const [hover, setHover] = useState(0);

  useEffect(() => {
    if (id) {
      // Logic to extract numeric ID from 'customer_1' or just '1'
      const extractedId = id.includes("customer_") ? id.split("_")[1] : id;
      setCustomerId(extractedId);
    } else {
      const queryParams = new URLSearchParams(window.location.search);
      const queryId = queryParams.get("customer_id");
      if (queryId) setCustomerId(queryId);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rating) {
      toast.error("Please select a star rating.");
      return;
    }

    const formData = {
      customer_id: customerId,
      customer_feedback_message: e.target.description.value,
      customer_feedback_rating: rating.toString(),
    };

    try {
      const response = await fetch(`${API_DOMAIN}/feedback.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.head.code === 200) {
        toast.success("Thanks for your review!"); // Show success toast
        setRating(0);
        e.target.reset();
        // Navigate after a short delay to let toast show
        setTimeout(() => {
          navigate("/chitfund");
        }, 2000); // Increased delay slightly for better visibility
      } else {
        toast.error("Error: " + result.head.msg);
      }
    } catch (error) {
      toast.error("Failed to connect to the server.");
    }
  };

  return (
    <>
      <AppBar />
      <Container className="mt-5" style={{ maxWidth: "500px" }}>
        <Card className="shadow-sm">
          <Card.Body>
            <Card.Title className="text-center mb-4">Write a Review</Card.Title>
            <Form onSubmit={handleSubmit}>
              {/* Star Rating Section */}
              <Form.Group className="mb-4 text-center">
                <Form.Label className="d-block">Your Rating</Form.Label>
                {[...Array(5)].map((_, index) => {
                  const ratingValue = index + 1;
                  return (
                    <label key={index}>
                      <input
                        type="radio"
                        name="rating"
                        style={{ display: "none" }}
                        value={ratingValue}
                        onClick={() => setRating(ratingValue)}
                      />
                      <FaStar
                        size={40}
                        style={{ cursor: "pointer", transition: "color 200ms" }}
                        color={
                          ratingValue <= (hover || rating)
                            ? "#ffc107"
                            : "#e4e5e9"
                        }
                        onMouseEnter={() => setHover(ratingValue)}
                        onMouseLeave={() => setHover(0)}
                      />
                    </label>
                  );
                })}
              </Form.Group>

              {/* Description Section */}
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  name="description"
                  as="textarea"
                  rows={4}
                  placeholder="Tell us about your experience..."
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100 btn-lg">
                Submit Review
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <ToastContainer position="top-center" autoClose={3000} />{" "}
      {/* Added props like in example */}
    </>
  );
};

export default Review;
